namespace $.$$ {
	export class $shm_showcase extends $.$shm_showcase {

		query( next?: string ) {
			return this.$.$mol_state_arg.value( 'showcase_search', next ) ?? ''
		}

		component_id( id: string ) { return id }

		group_title( id: string ) {
			return $shm_showcase_groups[ id as keyof typeof $shm_showcase_groups ]
		}

		@ $mol_mem
		entries_filtered() {
			const terms = this.query().toLocaleLowerCase().trim().split( /\s+/ )
			return $shm_showcase_entries.filter( entry => {
				const text = `${ entry.title } ${ $shm_showcase_fqn( entry ) } ${ entry.description }`.toLocaleLowerCase()
				return terms.every( term => text.includes( term ) )
			} )
		}

		@ $mol_mem
		groups_visible() {
			return Object.keys( $shm_showcase_groups )
				.filter( group => this.entries_filtered().some( entry => entry.group === group ) )
				.map( group => this.Group( group ) )
		}

		@ $mol_mem
		entries_ordered() {
			return Object.keys( $shm_showcase_groups ).flatMap( group => this.group_entries( group ) )
		}

		group_entries( group: string ) {
			const by = this.sort_by() === 'id' ? 'id' : 'title'
			const direction = this.sort_order() === 'desc' ? -1 : 1
			return this.entries_filtered()
				.filter( entry => entry.group === group )
				.sort( ( left, right )=> direction * ( by === 'id'
					? $shm_showcase_fqn( left ).localeCompare( $shm_showcase_fqn( right ), 'ru' )
					: left.title.localeCompare( right.title, 'ru' ) ) )
		}

		group_links( group: string ) {
			return this.group_entries( group ).map( entry => this.Menu_link( entry.id ) )
		}

		spread_ids() { return $shm_showcase_entries.map( entry => entry.id ) }

		spread_title( id: string ) {
			const entry = $shm_showcase_entries.find( entry => entry.id === id )
			return entry?.title ?? id
		}

		spread_current() {
			return this.spread_ids().includes( this.spread() ) ? this.Spread( this.spread() ) : this.Welcome()
		}

		@ $mol_mem
		pages() {
			return [
				...super.pages(),
				...this.spread_ids().includes( this.spread() ) ? [ this.Info( this.spread() ) ] : [],
			]
		}
	}
}
